/* =====================================================================
   META — мета-прогрессия: лучший забег, золото, перм-апгрейды,
   разблокировки, кодекс. Хранится в localStorage (lumen_meta).
   Вынесено из main для разрыва цикла зависимостей с bootstrap.
   ===================================================================== */

import { CONFIG } from './config';

export const Meta: any = {
  data: { best: 0, gold: 0, upgrades: {}, volume: 0.7, lang: '',
          maxDepth: 0, unlocks: {}, codex: {}, totalKills: 0, crt: true,
          totalRuns: 0, noWinStreak: 0, lastRunAt: 0, lastRunTime: 0, lastRunWon: false },
  load() {
    try {
      const s = localStorage.getItem('lumen_meta');
      if (s) this.data = Object.assign(this.data, JSON.parse(s));
    } catch (e) {}
    if (!this.data.upgrades) this.data.upgrades = {};
    if (!this.data.unlocks)  this.data.unlocks = {};
    if (!this.data.codex)    this.data.codex = {};
    if (this.data.maxDepth == null)  this.data.maxDepth = 0;
    if (this.data.totalKills == null) this.data.totalKills = 0;
    if (this.data.crt == null)       this.data.crt = true;   // дефолт: ретро-эффект вкл
    if (this.data.totalRuns == null)  this.data.totalRuns = 0;
    if (this.data.noWinStreak == null) this.data.noWinStreak = 0;
    if (this.data.lastRunAt == null)  this.data.lastRunAt = 0;
  },
  save() { try { localStorage.setItem('lumen_meta', JSON.stringify(this.data)); } catch (e) {} },
  recordBest(time: number) { if (time > this.data.best) this.data.best = time; },

  // Контент заперт, только если он есть в CONFIG.unlocks и веха ещё не взята.
  // Всё, чего нет в списке разблокировок, доступно по умолчанию.
  // ДЕМО-ГЕЙТ: в демо-сборке часть контента заперта НАВСЕГДА (полная версия), независимо от прогрессии.
  isUnlocked(key: string) {
    if (CONFIG.demo.enabled && CONFIG.demo.locked.includes(key)) return false;
    const u = CONFIG.unlocks.find((x: any) => x.key === key);
    if (!u) return true;
    return !!(this.data.unlocks && this.data.unlocks[key]);
  },

  // потолок выбираемой глубины: в демо — capped (лестница Глубин Тьмы — в полной версии)
  maxDepthAllowed() {
    const d = this.data.maxDepth || 0;
    return CONFIG.demo.enabled ? Math.min(d, CONFIG.demo.maxDepth) : d;
  },

  // Подвести итог забега: рекорд, киллы, кодекс, открыть следующую глубину,
  // проверить вехи разблокировок. Возвращает имена только что открытого.
  recordRun(stats: any) {
    if (!this.data.unlocks) this.data.unlocks = {};
    if (!this.data.codex)   this.data.codex = {};
    if (this.data.maxDepth == null)   this.data.maxDepth = 0;
    if (this.data.totalKills == null) this.data.totalKills = 0;
    this.recordBest(stats.time);
    this.data.totalKills += stats.kills || 0;
    // учёт забегов для между-забеговых фрагментов (§14.4): счётчик, серия без победы, время/итог/метка времени
    this.data.totalRuns = (this.data.totalRuns || 0) + 1;
    this.data.noWinStreak = stats.won ? 0 : (this.data.noWinStreak || 0) + 1;
    this.data.lastRunTime = stats.time || 0;
    this.data.lastRunWon = !!stats.won;
    this.data.lastRunAt = Date.now();
    if (stats.seen) for (const k of stats.seen) this.data.codex[k] = (this.data.codex[k] || 0) + 1;
    if (stats.won) {
      const next = (stats.depth || 0) + 1;
      if (next > this.data.maxDepth && next <= CONFIG.depths.length) this.data.maxDepth = next;
    }
    const freshly: any[] = [];
    for (const u of CONFIG.unlocks) {
      if (this.data.unlocks[u.key]) continue;
      const c = u.cond;
      const ok =
        (c.survive    != null && stats.time   >= c.survive) ||
        (c.level      != null && stats.level  >= c.level) ||
        (c.totalKills != null && this.data.totalKills >= c.totalKills) ||
        (c.killBoss   === true && stats.killedBoss) ||
        (c.win        === true && stats.won) ||
        (c.depth      != null && (stats.depth || 0) >= c.depth) ||
        (c.path       != null && stats.path === c.path) ||   // веха «открой, сыграв Путём X» (расширяемо)
        (c.totalRuns  != null && this.data.totalRuns >= c.totalRuns);   // ПРОГРЕССИВНОЕ РАСКРЫТИЕ систем (kind:'reveal')
      if (ok) { this.data.unlocks[u.key] = true; freshly.push(u.key); }
    }
    this.save();
    return freshly;
  },

  upgLevel(key: string) { return this.data.upgrades[key] || 0; },
  upgCost(key: string) {
    const u = CONFIG.shop.find((s: any) => s.key === key);
    const lv = this.upgLevel(key);
    return (lv >= u.max) ? null : u.cost[lv];
  },
  buy(key: string) {
    const c = this.upgCost(key);
    if (c == null || this.data.gold < c) return false;
    this.data.gold -= c;
    this.data.upgrades[key] = this.upgLevel(key) + 1;
    this.save();
    return true;
  },
};
